import { createContextualCan } from '@casl/react';

import { AbilityContext } from '@/setup/casl';

export const Can = createContextualCan(AbilityContext.Consumer);
